export type DailyDismissRecord = {
	day: string;
	version?: string;
};

const formatDay = (date: Date): string => {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
};

export const getTodayStamp = (): string => formatDay(new Date());

export const readDailyDismissRecord = (storageKey: string): DailyDismissRecord | null => {
	if (typeof window === 'undefined') return null;
	try {
		const rawValue = window.localStorage.getItem(storageKey);
		if (!rawValue) return null;
		const parsed = JSON.parse(rawValue);
		if (!parsed || typeof parsed !== 'object' || typeof parsed.day !== 'string') {
			return null;
		}
		const record: DailyDismissRecord = { day: parsed.day };
		if (typeof parsed.version === 'string') {
			record.version = parsed.version;
		}
		return record;
	} catch (error) {
		console.warn('Failed to read dismiss record', { storageKey, error });
		return null;
	}
};

export const writeDailyDismissRecord = (storageKey: string, record: DailyDismissRecord) => {
	if (typeof window === 'undefined') return;
	try {
		window.localStorage.setItem(storageKey, JSON.stringify(record));
	} catch (error) {
		console.warn('Failed to persist dismiss record', { storageKey, error });
	}
};

export const hasDismissedToday = (record: DailyDismissRecord | null): boolean => {
	if (!record) return false;
	return record.day === getTodayStamp();
};

export const shouldDisplayToday = (record: DailyDismissRecord | null, version?: string): boolean => {
	if (!record) return true;
	if (version && record.version !== version) return true;
	return !hasDismissedToday(record);
};
